import { render, staticRenderFns } from "./AllInsignias.vue?vue&type=template&id=5b145918"
import script from "./AllInsignias.vue?vue&type=script&lang=js"
export * from "./AllInsignias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports